import React from "react"
import Tabs from "../Tabs/Tabs"
import ModalButtons from "../ModalButtons/ModalButtons"
import AccountBuilderGeneral from "./tabs/AccountBuilderGeneral"
import AccountBuilderProperties from "./tabs/AccountBuilderProperties"

export default class AccountBuilder extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      ...this.props.account,
      activeTab: 'general',
    }

    this.onSave = this.onSave.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onChangeProperties = this.onChangeProperties.bind(this)
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)

    this.buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: ['data-dismiss="modal"']
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: this.onSave,
      },
    ]
  }

  render() {
    return (
      <div className="AccountBuilder">
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={this.buttons} />
          <Tabs

            tabs={[
              {targetName: 'general',
               tabName: I18n.t('general'),
               classes: this.state.activeTab === 'general' ? 'active' : null,
               changeHandler: this.onChangeActiveTab,
              },
              {targetName: 'properties',
               tabName: I18n.t('properties'),
               classes: this.state.activeTab === 'properties' ? 'active' : null,
               changeHandler: this.onChangeActiveTab,
              },
            ]}
          />
          <div className="tab-content">
            <AccountBuilderGeneral {...this.props} {...this.state} onChange={this.onChange} />
            <AccountBuilderProperties {...this.props} {...this.state} onChangeProperties={this.onChangeProperties} />
          </div>
        </div>
      </div>
    )
  }

  /**
  * Change handlers
  */

  onChange(e) {
    const { name, value } = e.target
    const { state } = this
    state[name] = value
    this.setState(state)
  }

  onChangeActiveTab(activeTab) {
    this.setState({activeTab: activeTab})
  }

  onChangeProperties(properties) {
    this.setState({properties: properties})
  }

  onSave() {
    var self = this;
		var account = this.prepParams()

		this.setState({ loading: true });

		$.ajax({
			type: 'POST',
			url: this.props.save_path,
			data: {
				account: account,
			}
		}).done((data) => {
			if (data && data.errors) {
				self.setState({loading: false, errors: data.errors});
			} else {
				if (parent && parent.refresh_data) {
					parent.refresh_data(I18n.t('account_saved_successfully'));
				}
				if (parent && parent.hide_modal) {
					parent.hide_modal();
				}
			}
    }).catch((data) => {
      if (data && data.responseJSON) {
        this.setState({ errors: data.responseJSON, loading: false });
        $('.modal-body').scrollTop(0);
      }
    });
  }

  /**
   * Helper functions
   */

  prepParams() {
    return {
			id: this.props.account ? this.props.account.id : null,
			name: this.state.name,
      booking_landing_page_url: this.state.booking_landing_page_url,
      email_domain: this.state.email_domain,
      url_display_name: this.state.url_display_name,
      property_ids: this.state.properties
    }
  }

}
